<button type="button" class="is-flex align-top linkWishlist btn-tertiary pt-8" (click)="clickWishlist($event)">
    <svg *ngIf="!isOnWishlist" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.66667 10.5455L12.3333 15V1H3V15L7.66667 10.5455ZM4 12.663L7.66667 9.16301L11.3333 12.663V2H4V12.663Z"
            fill="black"
        />
    </svg>

    <svg *ngIf="isOnWishlist" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.66667 10.5455L12.3333 15V1H3V15L7.66667 10.5455Z" fill="black" />
    </svg>
</button>
